import React from 'react';

import { isSpaLink, stripHost } from 'tradera/utils/url';
import { useUrlLocalizer } from 'tradera/lang/translate';
import { getImageSizes, getWebpImage } from '../image-sizes';
import { trackContainerClick } from '../analytics';
import MediaItem from '../media/media-item';
import ALink from 'tradera/components/alink/alink';
import css from './pop-cat-item.module.scss';
import classNames from 'classnames';
import { Button } from 'tradera/components/atoms/button/button';

export const PopCatItem = ({
    containerType,
    inSPA,
    item,
    itemCount,
    videoEnabled,
    totalCount,
    type,
    ...props
}) => {
    const {
        alternativeText,
        body,
        image,
        webpageUrl,
        heading,
        button,
        showHeading,
        trackingId,
        video
    } = item;
    const { toLocalizedUrl } = useUrlLocalizer();

    const showContent = showHeading || button || body;
    const imageSizes = getImageSizes(itemCount, image, containerType, false);
    const webpImage = getWebpImage(itemCount, image, containerType, false);
    const url = stripHost(toLocalizedUrl(webpageUrl ?? ''));

    const isPortrait = type === 'Portrait';
    const isLandscape = type === 'Landscape';
    const isSingleItemWithoutContent = totalCount === 1 && !showContent;
    const isSingleItemWithContent = totalCount === 1 && showContent;

    return (
        <ALink
            useLink={inSPA && isSpaLink(url)}
            aria-label={alternativeText || heading}
            href={url}
            onClick={() => trackContainerClick(containerType, trackingId)}
            {...props}
            className={classNames(css.wrapper, {
                [css.singleItem]: isSingleItemWithContent
            })}>
            <div
                className={classNames(css.media, 'bg-gray-300', {
                    [css.wide]: isSingleItemWithoutContent,
                    [css.portrait]: isPortrait,
                    [css.landscape]: isLandscape,
                    [css.singleItem]: isSingleItemWithContent
                })}>
                <MediaItem
                    alternativeText={alternativeText}
                    heading={heading}
                    imageSizes={imageSizes}
                    image={image}
                    video={videoEnabled ? video : null}
                    webpImage={webpImage}
                />
            </div>
            {showContent && (
                <div
                    className={classNames(
                        {
                            [css.portrait]: isPortrait,
                            [css.landscape]: isLandscape,
                            [css.singleItem]: isSingleItemWithContent
                        },
                        css.content
                    )}>
                    {showHeading && (
                        <h3 className="text-dark text-styled mb-1">
                            {heading}
                        </h3>
                    )}
                    {body && <p className="text-styled">{body}</p>}
                    {button && (
                        <Button
                            theme="primary"
                            brandedText
                            aria-label={alternativeText || heading}
                            size="xs"
                            className="font-weight-bold px-2">
                            {button}
                        </Button>
                    )}
                </div>
            )}
        </ALink>
    );
};
